import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SIGNUP_LINK_COLOR, StyledUILink } from '../../styles/TextInput.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackLink = ({
  onClick,
  href = ''
}) => {
  return /*#__PURE__*/_jsxs(StyledUILink, {
    href: href,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "left",
      color: SIGNUP_LINK_COLOR
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'button.back'
    })]
  });
};